import { Component } from "react";
import { compose } from "redux";

import Link from "admin/shared/ui/Link.Component";

// markup
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

// custom markup
import RetractableSidebar, {
  activeStyle,
} from "../../../home/components/Retractable.Sidebar";

// icons
import NewMPLIcon from "@material-ui/icons/AddBox";

import SvgIcon from "@material-ui/core/SvgIcon";
import { mplConnector } from "../../../../services/menu/mpl/connector";

class MPLComponent extends Component {
  getFinanceIcon = () => {
    /// the euro icon
    return (
      <SvgIcon>
        <path d="M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06c-.04.33-.06.66-.06 1 0 .34.02.67.06 1H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z" />
        <path d="M0 0h24v24H0z" fill="none" />
      </SvgIcon>
    );
  };

  render() {
    let wrapperStyle = {
      display: "flex",
      minHeight: "100%",
    };

    return (
      <div style={wrapperStyle}>
        <RetractableSidebar storageKey="mpl">
          <List>
            <Link
              activeClassName={"selected"}
              activeStyle={activeStyle}
              toState={"mplCreate"}
            >
              <ListItem button>
                <ListItemIcon>
                  <NewMPLIcon />
                </ListItemIcon>
                <ListItemText primary="Create MPL" />
              </ListItem>
            </Link>
            <Link
              activeClassName={"selected"}
              activeStyle={activeStyle}
              toState={"mplFinancing"}
            >
              <ListItem button>
                <ListItemIcon>{this.getFinanceIcon()}</ListItemIcon>
                <ListItemText primary="Financings" />
              </ListItem>
            </Link>
          </List>
        </RetractableSidebar>
        <div
          style={{
            width: "100%",
            boxSizing: "border-box",
            overflow: "auto",
            backgroundColor: "#f9f9f9",
          }}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}
export default compose(mplConnector)(MPLComponent);
